import PageHero from "@/components/base/PageHero";
import ScrollReveal from "@/components/base/ScrollReveal";
import SectionHeading from "@/components/base/SectionHeading";
import CompanySubNav from "@/pages/company/components/CompanySubNav";
import { VALUES } from "@/constants/site";

export default function CompanyPhilosophy() {
  return (
    <div className="w-full bg-background-50">
      <PageHero
        en="PHILOSOPHY"
        ja="経営理念"
        crumbs={[{ label: "企業情報", path: "/company" }, { label: "経営理念" }]}
      />
      <CompanySubNav />

      <section className="w-full py-20 md:py-28">
        <div className="mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <div className="flex flex-col items-center text-center">
              <span className="font-label text-xs tracking-[0.4em] text-accent-600">
                REVRA Group｜PHILOSOPHY
              </span>
              <h2 className="mt-6 font-display text-3xl font-light leading-[1.7] tracking-[0.05em] text-foreground-950 md:text-5xl">
                「ヒトが価値を創り、
                <br className="md:hidden" />
                ヒトが未来を変える」
              </h2>
              <p className="mt-8 max-w-2xl font-body text-[15px] leading-[2.2] text-foreground-700">
                私たちは、ヒトの可能性を信じる。挑戦を通じて一人ひとりの可能性を価値へと変え、
                その価値で未来を変えていく。
              </p>
            </div>
          </ScrollReveal>

          <div className="mt-20 grid grid-cols-1 gap-px border border-background-300/70 bg-background-300/70 md:grid-cols-2">
            <ScrollReveal>
              <div className="flex h-full flex-col bg-background-50 p-8 md:p-12">
                <span className="font-label text-xs tracking-[0.32em] text-accent-600">MISSION</span>
                <h3 className="mt-6 font-heading text-xl leading-[1.9] tracking-[0.04em] text-foreground-950">
                  「ヒトの可能性を、価値に変える」
                </h3>
                <p className="mt-5 font-body text-sm leading-[2.1] text-foreground-700">
                  一人ひとりの個性や才能を引き出し、社会に必要とされる価値へと変えていく。
                </p>
              </div>
            </ScrollReveal>
            <ScrollReveal delay={120}>
              <div className="flex h-full flex-col bg-background-50 p-8 md:p-12">
                <span className="font-label text-xs tracking-[0.32em] text-accent-600">VISION</span>
                <h3 className="mt-6 font-heading text-xl leading-[1.9] tracking-[0.04em] text-foreground-950">
                  「挑戦するヒトが、次の時代をつくる会社へ」
                </h3>
                <p className="mt-5 font-body text-sm leading-[2.1] text-foreground-700">
                  挑戦する仲間が集まり、共に成長し、新たな価値を生み出し続ける会社を目指す。
                </p>
              </div>
            </ScrollReveal>
          </div>
        </div>
      </section>

      <section className="relative w-full overflow-hidden bg-foreground-950 py-20 md:py-28">
        <div className="absolute inset-0 h-full w-full">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20minimal%20dark%20background%20with%20soft%20vertical%20light%20gradients%20and%20faint%20golden%20glow%20on%20deep%20black%2C%20elegant%20fine%20art%20photography%2C%20luxury%20brand%20aesthetic%2C%20mostly%20dark%20tones%2C%20calm%20sophisticated%20and%20refined&width=1600&height=1000&seq=revra-values-bg&orientation=landscape"
            alt="価値観イメージ"
            className="h-full w-full object-cover opacity-25"
          />
        </div>
        <div className="absolute inset-0 bg-foreground-950/70" />

        <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-12 lg:px-20">
          <ScrollReveal>
            <div className="flex flex-col items-center text-center">
              <span className="font-label text-xs tracking-[0.4em] text-accent-300">VALUE</span>
              <h2 className="mt-6 font-display text-3xl font-light tracking-[0.06em] text-background-50 md:text-4xl">
                大切にする5つの価値観
              </h2>
            </div>
          </ScrollReveal>

          <div className="mt-14 flex flex-col border-t border-background-50/15">
            {VALUES.map((value, index) => (
              <ScrollReveal key={value.no} delay={index * 70}>
                <div className="grid grid-cols-1 items-center gap-4 border-b border-background-50/15 py-7 md:grid-cols-[100px_1fr_1.2fr] md:gap-10 md:py-9">
                  <span className="font-label text-sm tracking-[0.24em] text-accent-400">
                    {value.no}
                  </span>
                  <div className="flex items-baseline gap-4">
                    <span className="font-heading text-xl tracking-[0.1em] text-background-50 md:text-2xl">
                      {value.ja}
                    </span>
                    <span className="font-label text-xs tracking-[0.24em] text-background-400">
                      {value.en.toUpperCase()}
                    </span>
                  </div>
                  <p className="font-body text-sm leading-[2] text-background-300">
                    {value.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}